import { InjectableClass } from '@fino/lib-injection';

export class TrackingService extends InjectableClass {
  constructor($window, $location, $log, $analytics) {
    'ngInject';
    super({ $window, $location, $log, $analytics });
  }

  activate() {}

  setUsername(userId) {
    this.$analytics.setUsername(userId);
  }

  setUserProperties(properties) {
    this.$analytics.setUserProperties(properties);
  }

  pageTrack(path, title, params) {
    if (angular.isUndefined(path) || path === null) {
      let props = this._getPageProperties();
      path = props.path;
      title = props.title;
    }
    this.$analytics.pageTrack(path, title, params);
  }

  eventTrack(action, properties, callback) {
    this.$analytics.eventTrack(action, properties, callback);
  }

  incrementProperty(property, value) {
    this.$analytics.incrementProperty(property, value);
  }

  userTimings(action, properties) {
    this.$analytics.userTimings(action, properties);
  }

  /*
   * Helper methods
   */
  _getPageProperties() {
    const path = this.$location.path();
    const title = this.$window.document.title;
    return {
      path, title
    };
  }
}
